import $ from 'jquery';
import Cache from 'root/cache';
import View from 'view/base';
import Constants from 'root/constants';
import View_User_Property_Filter from 'view/user_identification/user_property_filter';
import View_Question_Condition from './question_condition';
import Tooltip from 'root/module/tooltip';

const date_range = {
    0   : 'All time',
    1   : 'Today',
    7   : 'Last 7 days',
    30  : 'Last 30 days',
    90  : 'Last 3 months',
    365 : 'Last 12 months'
};

export default View.extend({
    className: 'survey-response-filters',

    views: {
        user_property_filter: {}
    },

    events: {
        'click .dropdown-date-range li'           : 'onSelectDateRange',
        'click .dropdown-segment li'              : 'onSelectSegment',
        'click .user-filter-toggle'               : 'onToggleUserFilter',
        'click .survey-question-condition-toggle' : 'onToggleQuestionConditionFilter',
        'click .survey-filters-clear'             : 'onClearFilters'
    },

    dom_handlers: {
        onSelectDateRange: function(e) {
            var val = $(e.currentTarget).data('val');

            this.filters.date_start = parseInt(val, 10);
            this.render();
            this.trigger('filter:change', this.getFilters(), ['date_start']);
        },
        onSelectSegment: function(e) {
            var is_all = $(e.currentTarget).data('val') === '';
            var segment_id = parseInt($(e.currentTarget).data('val'), 10);
            if (is_all) {
                this.filters.segments = [];
            } else {
                // only allow to select one segment
                this.filters.segments = [segment_id];
            }

            this.render();

            this.trigger('filter:change', this.getFilters(), ['segments']);
        },
        onToggleUserFilter: function(e) {
            if (this.$el.find('.region-user-properties').is(':visible')) {
                this.$el.find('.region-user-properties').hide();
                return;
            }

            this.$el.find('.region-user-properties').show();

            // hide answer filter
            this.$el.find('.region-question-condition-filter').hide();
        },
        onToggleQuestionConditionFilter: function(e) {
            if (this.$el.find('.region-question-condition-filter').is(':visible')) {
                this.$el.find('.region-question-condition-filter').hide();
                return;
            }

            this.$el.find('.region-user-properties').hide();
            this.$el.find('.region-question-condition-filter').show();
        },
        onClearFilters: function() {
            this.filters = {...this.filters, ...{
                segments: [],
                user_properties: {
                    segment_type: Constants.USER_SEGMENT_TYPE_AND,
                    segment_condition: []
                },
                question_condition: {
                    question_condition_type: Constants.QUESTION_CONDITION_TYPE_AND,
                    question_condition: []
                }
            }};

            this.trigger('filter:change', this.getFilters(), []);
            this.render();
            this.$el.find('.region-question-condition-filter').show();
            Tooltip.removeAll();
        },
        documentClick: function(e) {
            var user_properties_ignore_classes = [
                'condition-delete',
                'region-user-properties',
                'user-filter-toggle'
            ];

            var question_condition_ignore_classes = [
                'region-question-condition-filter',
                'survey-question-condition-toggle'
            ];

            var ignore_classes = user_properties_ignore_classes.concat(question_condition_ignore_classes);

            var ignore = false;

            ignore_classes.forEach((ignore_class) => {
                if ($(e.target).hasClass(ignore_class) || $(e.target).parents('.' + ignore_class).length > 0) {
                    ignore = true;
                }
            });

            if (ignore) {
                return;
            }

            this.$el.find('.region-user-properties').hide();
            this.$el.find('.region-question-condition-filter').hide();
        }
    },

    event_handlers: {
        onUserPropertyFilterSubmit: function(conditions) {
            this.$el.find('.region-user-properties').hide();

            this.filters.user_properties = conditions;
            this.render();

            this.trigger('filter:change', this.getFilters(), ['user_properties']);
        },
        onAnswerFilterSubmit: function(conditions) {
            this.$el.find('.region-question-condition-filter').hide();

            this.filters.question_condition = conditions;

            this.render();
            this.trigger('filter:change', this.getFilters(), ['question_condition']);
        }
    },

    getFilters: function() {
        return this.filters;
    },

    initialize: function(options) {
        this.filters = options || {
            segments: [],
            date_start: 0,
            user_properties: {
                segment_type: Constants.USER_SEGMENT_TYPE_AND,
                segment_condition: []
            },
            question_condition: {
                question_condition_type: Constants.QUESTION_CONDITION_TYPE_AND,
                question_condition: []
            }
        };

        $(document).on('click.' + this.cid, this.dom_handlers.documentClick.bind(this));

        this.on('remove', () => {
            $(document).off('click.' + this.cid);
        });
    },

    toggleClearButton: function() {
        this.$el.find('.survey-filters-clear').toggle(
            this.filters.segments.length > 0 ||
            this.filters.user_properties.segment_condition.length > 0 ||
            this.filters.question_condition.question_condition.length > 0
        );
    },

    render: function() {
        var segment_options = '';

        // build segment options
        Cache.user_segment.where({is_archived: false}).forEach((model) => {
            segment_options += '<li' + (this.filters.segments.indexOf(model.id) === -1 ? '' : ' class="selected"') + ' data-val="' + model.id + '">' + model.escape('segment_name') + '</li>';
        });

        var content =
        '<div class="button-dropdown button-dropdown-left margin-right-4" data-update="true">' +
            '<button type="button" class="dropdown-select dropdown-select-text font-weight-medium">' + date_range[this.filters.date_start] + '</button>' +
            '<div>' +
                '<ul class="dropdown dropdown-select dropdown-date-range">' +
                    '<li data-val="0"' + (this.filters.date_start === 0 ? ' class="selected"' : '') + '>All time</li>' +
                    '<li class="separator"></li>' +
                    '<li data-val="1">' + date_range[1] + '</li>' +
                    '<li data-val="7">' + date_range[7] + '</li>' +
                    '<li data-val="30">' + date_range[30] + '</li>' +
                    '<li data-val="90">' + date_range[90] + '</li>' +
                    '<li data-val="365">' + date_range[365] + '</li>' +
                '</ul>' +
            '</div>' +
        '</div>' +
        (Cache.account.hasFeature('user_segment') ?
        '<div class="button-dropdown button-dropdown-full button-dropdown-left margin-right-4" data-update="true" data-trim="false">' +
            '<button type="button" class="dropdown-select dropdown-select-text font-weight-medium">' +
            '<div class="flex-c">' +
                '<span>Segment</span>' +
                (this.filters.segments.length === 0 ? '' : '<span class="badge-primary badge-small badge-round badge-fluid font-weight-semibold margin-left-8">' + this.filters.segments.length + '</span>') +
            '</div>' +
            '</button>' +
            '<div>' +
                '<ul class="dropdown dropdown-select dropdown-segment">' +
                    '<li data-val=""' + (this.filters.segments.length === 0 ? ' class="selected"' : '') + '>All</li>' +
                    (segment_options ?
                    '<li class="separator"></li>' : '<li class="disabled">No segments created</li>') +
                    segment_options +
                '</ul>' +
            '</div>' +
        '</div>' : '') +
        '<div class="position-relative  margin-right-4">' +
            '<button type="button" class="user-filter-toggle dropdown-select dropdown-select-text font-weight-medium">' +
                '<div class="flex-c">' +
                    '<span>User Property</span>' +
                    (this.filters.user_properties.segment_condition.length === 0 ? '' : '<span class="badge-primary badge-small badge-round badge-fluid font-weight-semibold margin-left-8">' + this.filters.user_properties.segment_condition.length + '</span>') +
                '</div>' +
            '</button>' +
            '<div class="region-user-properties"></div>' +
        '</div>' +
        '<div class="position-relative  margin-right-4">' +
            '<button type="button" class="survey-question-condition-toggle dropdown-select dropdown-select-text font-weight-medium">' +
                '<div class="flex-c">' +
                    '<span>Question</span>' +
                    (this.filters.question_condition.question_condition.length === 0 ? '' : '<span class="badge-primary badge-small badge-round badge-fluid font-weight-semibold margin-left-8">' + this.filters.question_condition.question_condition.length + '</span>') +
                '</div>' +
            '</button>' +
            '<div class="region-question-condition-filter"></div>' +
        '</div>' +
        '<button type="button" class="survey-filters-clear small text-link tooltip" data-title="Clear filters" data-offset="0,10">Clear</button>';

        this.$el.html(content);

        if (this.views.user_property_filter instanceof View_User_Property_Filter) {
            this.views.user_property_filter.remove();
        }

        this.views.user_property_filter = new View_User_Property_Filter({
            segment_type: this.filters.user_properties.segment_type,
            segment_condition: this.filters.user_properties.segment_condition
        });

        this.views.user_property_filter.render().$el.appendTo(this.$el.find('.region-user-properties'));
        this.listenTo(this.views.user_property_filter, 'submit', this.event_handlers.onUserPropertyFilterSubmit.bind(this));

        if (this.views.question_condition instanceof View_Question_Condition) {
            this.views.question_condition.remove();
        }
        this.views.question_condition = new View_Question_Condition({
            question_condition_type: this.filters.question_condition.question_condition_type,
            question_condition: this.filters.question_condition.question_condition
        });
        this.views.question_condition.render().$el.appendTo(this.$el.find('.region-question-condition-filter'));
        this.listenTo(this.views.question_condition, 'submit', this.event_handlers.onAnswerFilterSubmit.bind(this));

        this.$el.find('.dropdown-date-range li[data-val="' + this.filters.date_start + '"]').addClass('selected');

        // hide the clear button if no filters are applied
        this.toggleClearButton();
        return this;
    }
});